import MutableTrack from "track/MutableTrack.js";
import Tone from 'tone';

export default superclass => class extends superclass  {
    initAudition() {
        var track = new MutableTrack(
            this.tracks.length,
            this,
            this.mixSession,
            this.numberOfPatterns(),
            () => this.update(),
            this.currentSubSequence);
        
        // set up the sends and effects
        track.setSends(this.sends);
        track.setupEffects();
        track.trackNumber = -2;
        track.trackNode.connect(Tone.Master);
        this.auditionTrack = track;
    }
}
